import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component } from '@angular/core';
import '@synergy-design-system/components/components/header/header.js';

// ---------------------------------------------------------------------
// 🔒 AUTOGENERATED @synergy-design-system/angular wrappers for @synergy-design-system/components
// Please do not edit this file directly!
// It will get recreated when running pnpm build.
// ---------------------------------------------------------------------
/**
 * @summary The <syn-header /> element provides a generic application header
 * that can be used to add applications name, toolbar and primary navigation.
 *
 * @documentation https://synergy-design-system.github.io/?path=/docs/components-syn-header--docs
 * @status stable
 * @since 1.10.0
 *
 * @slot label - The label for the header
 * @slot logo - The logo that should be displayed. Will fall back to the SICK logo if not provided
 * @slot meta-navigation - The meta-navigation is used to add various application toolbar icons
 *                     Best used with `<syn-icon-button />` and `<syn-drop-down />`
 * @slot navigation - This slot can be used to add an optional horizontal navigation
 * @slot open-burger-menu-icon - An icon to use in lieu of the default burger-menu=open state.
 *                      The default close icon is a 'x'.
 * @slot closed-burger-menu-icon - An icon to use in lieu of the default burger-menu=closed state.
 *                      The default open icon is a burger menu.
 *
 * @event syn-burger-menu-closed - Emitted when the burger menu is toggled to closed
 * @event syn-burger-menu-hidden - Emitted when the burger menu is toggled to hidden
 * @event syn-burger-menu-open - Emitted when the burger menu is toggled to open
 *
 * @csspart base - The component's base wrapper
 * @csspart content - The wrapper most content items reside
 * @csspart logo - The wrapper the application logo resides in
 * @csspart label - The element wrapping the application name
 * @csspart meta-navigation - The Item wrapping the optional application menu
 * @csspart navigation - The wrapper that is holding the optional top navigation section
 * @csspart burger-menu-toggle-button - The button that toggles the burger menu
 */
const _c0 = ["*"];
let SynHeaderComponent = /*#__PURE__*/(() => {
  class SynHeaderComponent {
    nativeElement;
    _ngZone;
    constructor(e, ngZone) {
      this.nativeElement = e.nativeElement;
      this._ngZone = ngZone;
      this.nativeElement.addEventListener('syn-burger-menu-closed', e => {
        this.synBurgerMenuClosedEvent.emit(e);
      });
      this.nativeElement.addEventListener('syn-burger-menu-hidden', e => {
        this.synBurgerMenuHiddenEvent.emit(e);
      });
      this.nativeElement.addEventListener('syn-burger-menu-open', e => {
        this.synBurgerMenuOpenEvent.emit(e);
      });
    }
    /**
     * The headers label.
     * If you need to display HTML, use the `label` slot instead.
     */
    set label(v) {
      this._ngZone.runOutsideAngular(() => this.nativeElement.label = v);
    }
    get label() {
      return this.nativeElement.label;
    }
    /**
    * Defines the current visibility and icon of the burger-menu icon.
    The menu button is added automatically if the component finds a syn-side-nav in
    variant="default".
    The following values can be used:
    - hidden: The burger menu is not visible
    - open: The burger menu is visible and shows the close icon
    - closed: The burger menu is visible and shows the open icon
    */
    set burgerMenu(v) {
      this._ngZone.runOutsideAngular(() => this.nativeElement.burgerMenu = v);
    }
    get burgerMenu() {
      return this.nativeElement.burgerMenu;
    }
    /**
     * Emitted when the burger menu is toggled to closed
     */
    synBurgerMenuClosedEvent = new EventEmitter();
    /**
     * Emitted when the burger menu is toggled to hidden
     */
    synBurgerMenuHiddenEvent = new EventEmitter();
    /**
     * Emitted when the burger menu is toggled to open
     */
    synBurgerMenuOpenEvent = new EventEmitter();
    static ɵfac = function SynHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SynHeaderComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SynHeaderComponent,
      selectors: [["syn-header"]],
      inputs: {
        label: "label",
        burgerMenu: "burgerMenu"
      },
      outputs: {
        synBurgerMenuClosedEvent: "synBurgerMenuClosedEvent",
        synBurgerMenuHiddenEvent: "synBurgerMenuHiddenEvent",
        synBurgerMenuOpenEvent: "synBurgerMenuOpenEvent"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SynHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
  return SynHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SynHeaderComponent };
